var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 31,
    viewBox: "0 0 25 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2810_4869)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0877 3.64648H3.5257C2.74878 3.64701 2.00383 3.95588 1.45447 4.50525C0.905099 5.05461 0.596233 5.79956 0.595703 6.57649V26.9065C0.596233 27.6834 0.905099 28.4284 1.45447 28.9777C2.00383 29.5271 2.74878 29.836 3.5257 29.8365H17.9017C18.6788 29.8362 19.424 29.5275 19.9736 28.9781C20.5232 28.4287 20.8322 27.6836 20.8327 26.9065V10.3915C20.8327 9.61348 20.5227 8.86749 19.9747 8.31749L16.1597 4.50449C15.8877 4.23229 15.5647 4.0164 15.2091 3.86917C14.8536 3.72195 14.4725 3.64627 14.0877 3.64648V3.64648Z",
    stroke: "#00B4F2",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9535 26.7867C21.7308 26.7864 22.4761 26.4776 23.0257 25.9279C23.5753 25.3783 23.8842 24.633 23.8845 23.8557V7.3427C23.8845 6.5637 23.5745 5.8187 23.0265 5.2687L19.2105 1.4547C18.9388 1.18256 18.6161 0.966628 18.261 0.819237C17.9058 0.671845 17.525 0.595887 17.1405 0.595703H6.57748C5.80014 0.595703 5.05462 0.904504 4.50495 1.45417C3.95529 2.00384 3.64648 2.74935 3.64648 3.5267",
    stroke: "#00B4F2",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 24H5V13H8V14H6V23H8V24H6Z",
    fill: "#4FB1EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 21V20H16V21H7ZM12 19V18H16V19H12ZM7 19V18H11V19H7ZM7 17V16H16V17H7Z",
    fill: "#4FB1EB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2810_4869"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 31,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.bd829c1d.svg";
export { ForwardRef as ReactComponent };